import React from 'react';
import './simple-alert.css';

class SimpleAlert extends React.Component{
  constructor(props){
    super(props);
    this.state={title:props.title,message:props.message};
  }

  render(){
    return(
      <div>
        <div className="simple-alert-title">{this.state.title}</div>
        <div className="simple-alert-message">{this.state.message}</div>
      </div>
    )
  }
}


export default SimpleAlert;



// WEBPACK FOOTER //
// ./src/components/alert/types/SimpleAlert.js